import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  sport: "Baseball" as string,
  themeColor: "" as string,
};

const settingsSlice = createSlice({
  name: "settings",
  initialState,
  reducers: {
    setSport: (state, action) => {
      state.sport = action.payload;
    },
    setThemeColor: (state, action) => {
      state.themeColor = action.payload;
    },
  },
});

export const { setSport, setThemeColor } = settingsSlice.actions;
export default settingsSlice.reducer;
